import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import FormDelete from '../components/form-delete/form-delete';
import FormCreate from '../components/form-manager/form-manager';
import SearchResult from '../components/search-result/search-result';
import Communication from '../components/communication/communication';
import Header from '../../../components/header/header';

import { search, setDefaultPageRules } from '../actions/form-search';
import { getUsersOptions } from '../../../actions/select-options';

class SettingsIntegrationCalendar extends Component {
  componentDidMount() {
    const {
      search,
      setDefaultPageRules,
      getUsersOptions,
    } = this.props;

    setDefaultPageRules();
    search({
      page: 1,
      limit: 60,
    });

    getUsersOptions();
  }

  render() {
    const {
      userLogged,
    } = this.props;

    return (
      <>
        <Header userLogged={userLogged} />
        <SearchResult />

        <FormDelete />
        <FormCreate />
        <Communication />
      </>
    )
  }
}

const mapStateToProps = ({ authReducer: { authenticated } }) => ({
  userLogged: authenticated,
});

const mapDispatchToProps = dispath => {
  return bindActionCreators({
    search,
    setDefaultPageRules,
    getUsersOptions,
  }, dispath)
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingsIntegrationCalendar);
